// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerLink":"Footer_footerLink__xVufR"};